/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_DescriptionInputs */

const en_directory_search_description = /** @type {(inputs: Directory_Search_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search published Seek AI products by name, topic, or the problem you need to solve.`)
};

const zh_directory_search_description = /** @type {(inputs: Directory_Search_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按名称、主题或需要解决的问题，搜索 Seek AI 已发布产品。`)
};

/**
* | output |
* | --- |
* | "Search published Seek AI products by name, topic, or the problem you need to solve." |
*
* @param {Directory_Search_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_search_description = /** @type {((inputs?: Directory_Search_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_search_description(inputs)
	return zh_directory_search_description(inputs)
});
export { directory_search_description as "directory.search.description" }